<template>
  <div class="app-password-success text-start text-center">
    <span class="app-password-success__icon material-icons text-success">
      task_alt
    </span>

    <p class="mt-4 text-sm">
      Het nieuwe wachtwoord is opgeslagen.<br />
      Je kunt nu in de app inloggen met het nieuwe wachtwoord.
    </p>

    <material-button class="mb-0" color="primary" variant="gradient" @click.prevent="goToSite">
      Naar Clubcows
    </material-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { validateOTP } from '@/api/providers/account';
import MaterialButton from '@/components/MaterialButton.vue';

export default {
  name: "LoginPassword",

  components: {
    MaterialButton
  },

  data: () => ({
    error: '',
    loading: false,
    password: '',
  }),

  methods: {
    ...mapActions('account', [
      'setAuth',
      'setOrganizations',
      'setPermissions',
    ]),

    goToSite() {
      window.open('https://clubcows.com/', '_blank').focus();

    },

    submit() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      validateOTP(this.$route.params.username, this.password)
        .then(({ auth, allowedToImportUsers, organizations }) => {
          this.setAuth(auth);
          this.setPermissions({
            allowedToImportUsers,
          });

          this.setOrganizations(organizations);

          this.$router.push({
            name: 'account-organisations',
          });
        })
        .catch(({ message }) => {
          console.error(message);
          this.error = message;
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.app-password-success {

  &__icon {
    font-size: 90px;
  }
}
</style>
